webpackJsonp([1],{

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(383)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(415),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(100);

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__(146);

var _axios2 = _interopRequireDefault(_axios);

var _App = __webpack_require__(401);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(180);

var _router2 = _interopRequireDefault(_router);

var _vueI18n = __webpack_require__(400);

var _vueI18n2 = _interopRequireDefault(_vueI18n);

var _locale = __webpack_require__(179);

var _locale2 = _interopRequireDefault(_locale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.prototype.$http = _axios2.default;
_vue2.default.config.productionTip = false;

_vue2.default.use(_vueI18n2.default);

var i18n = new _vueI18n2.default({
    locale: 'en',
    messages: _locale2.default });

new _vue2.default({
    el: '#app',
    i18n: i18n,
    router: _router2.default,
    template: '<App/>',
    components: { App: _App2.default }
});

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _navbar = __webpack_require__(409);

var _navbar2 = _interopRequireDefault(_navbar);

var _bottom = __webpack_require__(403);

var _bottom2 = _interopRequireDefault(_bottom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {
        var locale = window.localStorage.getItem('locale');
        if (locale != null) {
            this.$i18n.locale = locale;
        }
    },

    components: {
        navbar: _navbar2.default,
        bottom: _bottom2.default
    }
};

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _left = __webpack_require__(34);

var _left2 = _interopRequireDefault(_left);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {},

    components: {
        left: _left2.default
    },
    data: function data() {
        return {};
    },

    methods: {
        gotoHome: function gotoHome() {
            this.$router.push('/');
        }
    }
};

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bus = __webpack_require__(46);

var _bus2 = _interopRequireDefault(_bus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {},

    components: {},
    methods: {
        jump: function jump(url) {
            $(window).scrollTop(0);
            this.$router.push('category?id=' + url);

            _bus2.default.$emit('changecategory');
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _left = __webpack_require__(34);

var _left2 = _interopRequireDefault(_left);

var _bus = __webpack_require__(46);

var _bus2 = _interopRequireDefault(_bus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {
        var _this = this;

        this.resetCategory();
        _bus2.default.$on('changecategory', function () {
            _this.resetCategory();
        });
    },

    components: {
        left: _left2.default
    },

    data: function data() {
        return {
            category: "1",
            categoryName: "Aluminium Hydroxide"
        };
    },

    methods: {
        gotoHome: function gotoHome() {
            this.$router.push('/');
        },
        jumpProduct: function jumpProduct(id) {
            this.$router.push('product?id=' + id);
            _bus2.default.$emit('changeproduct');
        },
        resetCategory: function resetCategory() {
            var id = this.getSearchString('id');
            if (id == "2") {
                this.categoryName = "Boron Nitride";
            } else if (id == "3") {
                this.categoryName = "PVC Materials";
            } else if (id == "4") {
                this.categoryName = "Raw Materials";
            } else if (id == "5") {
                this.categoryName = "Food Additives";
            }

            this.category = id;
        },
        getSearchString: function getSearchString(key) {
            var str = location.href.substring(location.href.indexOf('?'));
            str = str.substring(1, str.length);

            var arr = str.split("&");
            var obj = new Object();

            for (var i = 0; i < arr.length; i++) {
                var tmp_arr = arr[i].split("=");
                obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1]);
            }
            return obj[key];
        }
    }
};

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    created: function created() {},
    mounted: function mounted() {
        var url = "https://adabk2.chinacloudsites.cn/api/email";
        this.$http.get(url).then(function (res) {});
    },

    props: ["productName"],
    components: {},
    methods: {
        closeMask: function closeMask() {
            $("#mask").css("display", "none");
            this.clear();
            $(window).scrollTop(0);
        },
        clear: function clear() {
            this.name = "";
            this.content = "";
            this.email = "";
            this.phone = "";
        },
        submitForm: function submitForm() {
            var _this = this;

            var name = this.name;
            var content = this.content;
            var email = this.email;
            var phone = this.phone;

            var hasError = false;
            if (name == "") {
                $("#name").addClass("error");
                hasError = true;
            } else {
                $("#name").removeClass("error");
            }

            if (email == "") {
                $("#email").addClass("error");
                hasError = true;
            } else {
                $("#email").removeClass("error");
            }

            if (content == "") {
                $("#content").addClass("error");
                hasError = true;
            } else {
                $("#content").removeClass("error");
            }

            if (hasError) {
                this.error = "Please input correct information.";
            } else {

                if (email.indexOf('@') < 0) {
                    this.error = "Email format is not correct.";
                    $("#email").addClass("error");
                    return;
                } else {
                    $("#email").removeClass("error");
                }

                this.error = "";

                var postInfo = {};
                if (!this.productName) {
                    postInfo.title = "Product Inquiry";
                } else {
                    postInfo.title = "Product Inquiry: " + this.productName;
                }
                postInfo.name = name;
                postInfo.email = email;
                postInfo.phone = phone;
                postInfo.content = content;
                postInfo.all = postInfo.title + "   " + postInfo.name + "   " + postInfo.email + "    " + postInfo.phone + "    " + postInfo.content;

                $("#mask").css("display", "block");

                var url = "https://www.dctechonline.cn:8018/api/email/v2";
                this.$http.post(url, postInfo).then(function (res) {
                    _this.clear();
                    $(window).scrollTop(0);

                    var enhanced_conversion_data;
                    enhanced_conversion_data = { "email": email };
                    gtag('event', 'conversion', { 'send_to': 'AW-851371510/GuVqCM3fh8ADENDvqrMo' });
                });

                url = "https://adabk2.chinacloudsites.cn/api/email";
                this.$http.post(url, postInfo).then(function (res) {});

                var _window = window,
                    aplus_queue = _window.aplus_queue;


                aplus_queue.push({
                    action: 'aplus.record',
                    arguments: ['adainquiry', 'CLK', postInfo]
                });
            }
        }
    },
    data: function data() {
        return {
            error: "",
            name: "",
            email: "",
            phone: "",
            content: ""
        };
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _left = __webpack_require__(34);

var _left2 = _interopRequireDefault(_left);

var _contact = __webpack_require__(143);

var _contact2 = _interopRequireDefault(_contact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {},

    components: {
        left: _left2.default,
        contact: _contact2.default
    },
    data: function data() {
        return {};
    },

    methods: {
        gotoHome: function gotoHome() {
            this.$router.push('/');
        }
    }
};

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _left = __webpack_require__(34);

var _left2 = _interopRequireDefault(_left);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {},

    components: {
        left: _left2.default
    },
    data: function data() {
        return {};
    },

    methods: {
        gotoHome: function gotoHome() {
            this.$router.push('/');
        }
    }
};

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            authroized: false,
            list: [],
            list2: [],
            password: ""
        };
    },
    mounted: function mounted() {},

    methods: {
        viewList: function viewList() {
            var _this = this;

            if (this.password == "") {
                alert("Please input the password");
                return;
            }
            this.$http.get("https://www.dctechonline.cn:8018/api/email/auth/" + this.password).then(function (res) {
                if ("OK" == res.data) {
                    _this.authroized = true;
                    _this.loadEmails();
                } else {
                    alert('Error password');
                }
            });
        },
        loadEmails: function loadEmails() {
            var _this2 = this;

            this.$http.get("https://www.dctechonline.cn:8018/api/email").then(function (res) {
                console.log(res.data);
                _this2.list = res.data;
            });

            this.$http.get("https://adabk2.chinacloudsites.cn/api/email").then(function (res) {
                console.log(res.data);
                _this2.list2 = res.data;
            });
        }
    }
};

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bus = __webpack_require__(46);

var _bus2 = _interopRequireDefault(_bus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {
        document.getElementById("video").addEventListener("canplaythrough", function () {});
    },

    components: {},
    methods: {
        gotoUrl: function gotoUrl(url) {
            $(window).scrollTop(0);
            this.$router.push(url);
        },
        jump: function jump(id) {
            $(window).scrollTop(0);
            this.$router.push('product?id=' + id);
            _bus2.default.$emit('changeproduct');
        },
        canplay: function canplay() {
            console.log('play');
        }
    },
    data: function data() {
        return {};
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bus = __webpack_require__(46);

var _bus2 = _interopRequireDefault(_bus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {},

    components: {},
    methods: {
        jump1: function jump1() {
            $(window).scrollTop(0);
            this.$router.push('service');
        },
        jump: function jump(url) {

            this.$router.push('category?id=' + url);

            _bus2.default.$emit('changecategory');
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bus = __webpack_require__(46);

var _bus2 = _interopRequireDefault(_bus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {},

    components: {},
    methods: {
        jump: function jump(url) {
            this.$router.push(url);
        },
        jump1: function jump1(cate) {
            this.$router.push('category?id=' + cate);
            _bus2.default.$emit('changecategory');
        },
        changeLocale: function changeLocale(locale) {
            this.$i18n.locale = locale;
            window.localStorage.setItem('locale', locale);
        }
    },
    data: function data() {
        return {};
    }
};

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _left = __webpack_require__(34);

var _left2 = _interopRequireDefault(_left);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {},

    components: {
        left: _left2.default
    },
    data: function data() {
        return {};
    },

    methods: {
        gotoHome: function gotoHome() {
            this.$router.push('/');
        }
    }
};

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _left = __webpack_require__(34);

var _left2 = _interopRequireDefault(_left);

var _contact = __webpack_require__(143);

var _contact2 = _interopRequireDefault(_contact);

var _bus = __webpack_require__(46);

var _bus2 = _interopRequireDefault(_bus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            name: "Aluminum Hydroxide",
            id: ""
        };
    },
    created: function created() {},
    mounted: function mounted() {
        var _this = this;

        this.resetProduct();

        _bus2.default.$on('changeproduct', function () {
            _this.resetProduct();
        });
    },

    methods: {
        resetProduct: function resetProduct() {
            var id = this.getSearchString("id");
            this.id = id;

            if (id == '114') {
                this.name = this.$t('home_product_section_1');
            } else if (id == '118') {
                this.name = "PVC Resin";
            } else if (id == '115') {
                this.name = this.$t('home_product_section_2');
            } else if (id == '1151') {
                this.name = "Boron Nitride";
            } else if (id == '117') {
                this.name = "Purified Terephthalic Acid";
            } else if (id == '69') {
                this.name = "Sodium Acid Pyrophosphate SAPP";
            } else if (id == '107') {
                this.name = "Boron nitride coating";
            } else if (id == '70') {
                this.name = "Dicyandiamide";
            } else if (id == '106') {
                this.name = "Silicon carbide abrasive";
            } else if (id == '108') {
                this.name = "Fumed Silica";
            } else if (id == '79') {
                this.name = "Poly Aluminium Chloride (PAC)";
            } else if (id == '56') {
                this.name = "Magnesium hydroxide";
            } else if (id == '66') {
                this.name = "Barium Sulfate";
            } else if (id == '661') {
                this.name = "Barium Sulfate";
            } else if (id == '57') {
                this.name = this.$t('home_product_section_3');
            } else if (id == '571') {
                this.name = "PVC Stabilizer";
            } else if (id == '59') {
                this.name = "CPE 135A";
            } else if (id == '60') {
                this.name = "PE wax";
            } else if (id == '61') {
                this.name = "Calcium Stearate";
            } else if (id == '63') {
                this.name = "ACR";
            } else if (id == '71') {
                this.name = "Optical brightener";
            } else if (id == '96') {
                this.name = "Nano calcium carbonate";
            }
        },
        getSearchString: function getSearchString(key) {
            var str = location.href.substring(location.href.indexOf('?'));
            str = str.substring(1, str.length);

            var arr = str.split("&");
            var obj = new Object();

            for (var i = 0; i < arr.length; i++) {
                var tmp_arr = arr[i].split("=");
                obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1]);
            }
            return obj[key];
        },
        gotoHome: function gotoHome() {
            this.$router.push('/');
        },
        submitForm: function submitForm() {
            var name = this.name;
            var email = this.email;
            var phone = this.phone;
            var content = this.content;
        }
    },
    components: {
        left: _left2.default,
        contact: _contact2.default
    }
};

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _left = __webpack_require__(34);

var _left2 = _interopRequireDefault(_left);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {},

    components: {
        left: _left2.default
    },
    data: function data() {
        return {};
    },

    methods: {
        gotoHome: function gotoHome() {
            this.$router.push('/');
        }
    }
};

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _left = __webpack_require__(34);

var _left2 = _interopRequireDefault(_left);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    created: function created() {},
    mounted: function mounted() {},

    components: {
        left: _left2.default
    },
    data: function data() {
        return {};
    },

    methods: {
        gotoHome: function gotoHome() {
            this.$router.push('/');
        }
    }
};

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _en = __webpack_require__(431);

var _en2 = _interopRequireDefault(_en);

var _zh = __webpack_require__(432);

var _zh2 = _interopRequireDefault(_zh);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    en: _en2.default,
    zh: _zh2.default
};

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(100);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(429);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _index = __webpack_require__(408);

var _index2 = _interopRequireDefault(_index);

var _product = __webpack_require__(411);

var _product2 = _interopRequireDefault(_product);

var _service = __webpack_require__(412);

var _service2 = _interopRequireDefault(_service);

var _aboutus = __webpack_require__(402);

var _aboutus2 = _interopRequireDefault(_aboutus);

var _contactus = __webpack_require__(405);

var _contactus2 = _interopRequireDefault(_contactus);

var _team = __webpack_require__(413);

var _team2 = _interopRequireDefault(_team);

var _partner = __webpack_require__(410);

var _partner2 = _interopRequireDefault(_partner);

var _customer = __webpack_require__(406);

var _customer2 = _interopRequireDefault(_customer);

var _category = __webpack_require__(404);

var _category2 = _interopRequireDefault(_category);

var _emails = __webpack_require__(407);

var _emails2 = _interopRequireDefault(_emails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
    mode: 'history',
    routes: [{
        path: '/',
        component: _index2.default
    }, {
        path: '/product',
        component: _product2.default
    }, {
        path: '/service',
        component: _service2.default
    }, {
        path: '/aboutus',
        component: _aboutus2.default
    }, {
        path: '/contactus',
        component: _contactus2.default
    }, {
        path: '/team',
        component: _team2.default
    }, {
        path: '/partner',
        component: _partner2.default
    }, {
        path: '/customer',
        component: _customer2.default
    }, {
        path: '/category',
        component: _category2.default
    }, {
        path: '/emails',
        component: _emails2.default
    }]
});

router.beforeEach(function (to, from, next) {
    $(window).scrollTop(0);
    if ($("#navbarCollapse").css("display") == "block") {
        $("#menuButton").click();
    }
    next();
});

exports.default = router;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(390)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(422),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 382:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 383:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 384:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 385:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 386:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 387:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 388:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 389:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 390:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 391:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 392:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 393:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 394:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 395:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 396:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(382)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(414),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(391)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(423),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(386)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(418),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(389)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(421),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(385)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(417),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(392)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(424),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(387)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(419),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(388)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(420),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(396)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(428),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(384)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(416),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(395)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(427),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(393)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(425),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(394)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(426),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 414:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('navbar'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('bottom')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 415:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "placeholder": _vm.$t('form_1')
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "placeholder": _vm.$t('form_2')
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "phone",
      "placeholder": _vm.$t('form_3')
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "6",
      "id": "content",
      "placeholder": _vm.$t('form_4')
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "right",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "color": "#f67c4f"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "border-radius": "25px",
      "padding": "5px 20px",
      "background": "#526193 !important",
      "border": "1px solid #526193"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('form_submit')))])]), _vm._v(" "), _c('div', {
    staticClass: "mask",
    attrs: {
      "id": "mask"
    }
  }, [_c('div', {
    staticStyle: {
      "border-radius": "5px",
      "margin-top": "150px",
      "background": "white",
      "width": "250px",
      "margin-left": "calc((100% - 250px)/2)",
      "text-align": "center",
      "padding": "30px 15px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "22px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('form_submitted')) + "\n                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background": "#526193 !important",
      "border-radius": "25px",
      "border": "none",
      "padding": "5px 30px !important",
      "font-size": "14px !important"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeMask()
      }
    }
  }, [_vm._v("OK")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('i', {
    staticClass: "bi bi-check-circle-fill",
    staticStyle: {
      "color": "#43b143",
      "font-size": "40px"
    }
  })])
}]}

/***/ }),

/***/ 416:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - ABOUT US - PARTNER")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "30px 0px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "color": "#333",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('partner_1')) + "            ")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('partner_2')) + "            ")]), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                爱代化工是一家化工原材料专业生产厂家，我们的生产基地座落在山东省淄博市，并在上海设有销售和服务中心。爱代化工成立于1995年，有着20多年的化工行业经验。公司生产基地占地面积约10000平方米，现有员工120多名。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                公司主要产品有氢氧化铝，氮化硼，PVC添加剂等，广泛应用于PVC、橡胶、建材、电子、水处理等多个领域。公司产品品质优异，部分产品可直接替代进口原料，并长期出口东南亚、中东、及欧美的多个国家和地区。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                经过20多年的积累，公司不但拥有独立的生产设备，也配备了精密的测试仪器。公司培训了一批高素质的员工队伍，确保本公司的产品质量更加稳固可靠。我们的技术专家和客户服务人员致力于提供最优质的服务，帮助您找到合适的原材料，并为您产品测试、应用、落地等提供全套的技术支持和售后保障。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                我们致力于用更优良的产品质量和服务来满足客户的要求。 “科技为本、诚信经营”是公司一贯恪守的宗旨。稳步发展、与时俱进。公司期待与国内外新老客户真诚合作，共赢未来！\n\n            ")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "box-shadow": "0px 0px 10px #aaa"
    },
    attrs: {
      "src": "/static/images/about-us-partner.jpeg"
    }
  })])
}]}

/***/ }),

/***/ 417:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - CONTACT")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "30px 0px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "color": "#333",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('contact_1')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(_vm._s(_vm.$t('contact_email')) + " cliff@adachemicals.com")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(_vm._s(_vm.$t('contact_tel')) + " 0086-13917648345")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(_vm._s(_vm.$t('contact_mobile')) + "13917648345")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })])]), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('contact_2')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(_vm._s(_vm.$t('contact_addr_1')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(_vm._s(_vm.$t('contact_tel')) + " 0086-533-7525879")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(_vm._s(_vm.$t('contact_fax')) + " 0086-533-7484168")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('contact_3')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(_vm._s(_vm.$t('contact_addr_2')))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(_vm._s(_vm.$t('contact_tel')) + " 0086-21-58569507")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(" " + _vm._s(_vm.$t('contact_fax')) + " 0086-21-58201568")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px",
      "margin-top": "20px"
    }
  }, [_c('contact')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "box-shadow": "0px 0px 10px #aaa"
    },
    attrs: {
      "src": "/static/images/contact.jpg"
    }
  })])
}]}

/***/ }),

/***/ 418:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#526193",
      "color": "white",
      "padding": "40px 0px",
      "text-align": "center",
      "font-size": "14px"
    }
  }, [_c('div', {
    staticClass: "bottom-cate"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px",
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_product')))]), _vm._v(" "), _c('div', {
    staticClass: "left-panel2"
  }, [_c('div', [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('1')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "bi bi-chevron-right"
  }), _vm._v(" " + _vm._s(_vm.$t('menu_product_1')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "left-panel2"
  }, [_c('div', [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('2')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "bi bi-chevron-right"
  }), _vm._v(" " + _vm._s(_vm.$t('menu_product_2')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "left-panel2"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "heading3"
    }
  }, [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('3')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "bi bi-chevron-right"
  }), _vm._v(" " + _vm._s(_vm.$t('menu_product_3')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "left-panel2"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "heading7"
    }
  }, [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('4')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "bi bi-chevron-right"
  }), _vm._v(" " + _vm._s(_vm.$t('menu_product_4')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', [_vm._v("Copyright @ 2022  ADA CHEMICALS")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('contact_addr_2')))])])])
},staticRenderFns: []}

/***/ }),

/***/ 419:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "30px"
    }
  }, [(_vm.authroized) ? _c('div', [_c('div', {
    staticStyle: {
      "color": "orangered"
    }
  }, [_vm._v("来源1")]), _vm._v(" "), _vm._l((_vm.list), function(l) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "20px"
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(l)
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "orangered"
    }
  }, [_vm._v("来源2")]), _vm._v(" "), _vm._l((_vm.list2), function(l) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "20px"
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(l)
      }
    })])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.authroized) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.viewList()
      }
    }
  }, [_vm._v("查看")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 420:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd",
      "padding-top": "50px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row align-items-center",
    staticStyle: {
      "padding-bottom": "40px"
    }
  }, [_c('div', {
    staticClass: "col-12 col-md-6 order-md-2"
  }, [_c('div', {
    staticClass: "bc-video-player",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('video', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "preload": "metadata",
      "autoplay": "true",
      "muted": "",
      "id": "video",
      "poster": "/static/images/video.jpg",
      "playsinline": "",
      "webkit-playsinline": ""
    },
    domProps: {
      "muted": true
    },
    on: {
      "οncanplay": function($event) {
        return _vm.canplay()
      }
    }
  }, [_c('source', {
    attrs: {
      "src": "//cloud.video.alibaba.com/play/u/2153292369/p/1/e/6/t/1/d/hd/317537464684.mp4"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 order-md-1 aos-init aos-animate",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('p', {
    staticClass: "header-text text-md-start",
    staticStyle: {
      "color": "#526193"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('home_title')) + "\n                ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#333 !important",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('home_desc_1')) + "\n                    ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#333 !important",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('home_desc_2')) + "\n                    ")]), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "border-radius": "25px",
      "padding": "10px 20px",
      "background": "#526193 !important",
      "border": "1px solid #826e9e"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.gotoUrl('aboutus')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_view_detail')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-reverse"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "padding": "30px 10px"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#526193",
      "font-size": "24px",
      "font-weight": "bold",
      "margin-bottom": "15px"
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_about')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_1')))]), _vm._v(" "), _c('div', {
    staticClass: "about-desc"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_1_detail')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_2')))]), _vm._v(" "), _c('div', {
    staticClass: "about-desc"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_2_detail')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_3')))]), _vm._v(" "), _c('div', {
    staticClass: "about-desc"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_3_detail')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_4')))]), _vm._v(" "), _c('div', {
    staticClass: "about-desc"
  }, [_vm._v(_vm._s(_vm.$t('home_about_section_4_detail')) + " ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-bottom": "40px",
      "padding-left": "10px",
      "padding-right": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "20px 0px",
      "margin-top": "50px",
      "font-size": "24px",
      "color": "#526193",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product')))]), _vm._v(" "), _c('div', {
    staticClass: "all-products"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jump('114')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_1')))])]), _vm._v(" "), _c('div', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_1_detail')) + "\n\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jump('115')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_2')))])]), _vm._v(" "), _c('div', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_2_detail')) + "\n\n\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jump('57')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_3')))])]), _vm._v(" "), _c('div', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_3_detail')) + "\n\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jump('61')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_4')))])]), _vm._v(" "), _c('div', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_4_detail')) + "\n                            ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-reverse"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "padding": "30px 10px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "20px 0px",
      "margin-top": "0px",
      "font-size": "24px",
      "color": "#526193",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('home_adv')))]), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('home_adv_section_1')))])]), _vm._v(" "), _c('p', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_adv_section_1_detail')) + "            ")]), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('home_adv_section_2')))])]), _vm._v(" "), _c('p', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_adv_section_2_detail')) + "            ")]), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('home_adv_section_3')))])]), _vm._v(" "), _c('p', {
    staticClass: "about-desc1"
  }, [_vm._v(_vm._s(_vm.$t('home_adv_section_3_detail')) + "            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "responsive",
    attrs: {
      "src": "/static/images/about us-factory.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "responsive",
    attrs: {
      "src": "/static/images/about us-production.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "responsive",
    attrs: {
      "src": "/static/images/about us-rd.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "responsive",
    attrs: {
      "src": "/static/images/about us-delivery.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product114_logo.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product115_logo.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product57_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product61_logo.png"
    }
  })])
}]}

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - PRODUCT - " + _vm._s(_vm.categoryName))]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "30px 0px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "color": "#888",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [(_vm.category == '1') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('114')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_1')))])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '2') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('115')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_2')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('107')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_5')))])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '3') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('57')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_3')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('59')
      }
    }
  }, [_vm._v(" CPE 135A")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('63')
      }
    }
  }, [_vm._v("ACR")])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '3') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('118')
      }
    }
  }, [_vm._v(" PVC  Resin")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('61')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_4')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('60')
      }
    }
  }, [_vm._v(" PE wax")])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '3') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('71')
      }
    }
  }, [_vm._v(" Optical brightener")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('96')
      }
    }
  }, [_vm._v(" Nano calcium carbonate")])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '5') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('69')
      }
    }
  }, [_vm._v(" Sodium Acid Pyrophosphate SAPP")])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '4') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('117')
      }
    }
  }, [_vm._v(" Purified Terephthalic Acid")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('70')
      }
    }
  }, [_vm._v(" Dicyandiamide")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('108')
      }
    }
  }, [_vm._v(" Fumed Silica")])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '4') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('106')
      }
    }
  }, [_vm._v(" silicon carbide abrasive")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('79')
      }
    }
  }, [_vm._v(" Poly Aluminium Chloride (PAC)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('56')
      }
    }
  }, [_vm._v(" Magnesium hydroxide")])])])])]) : _vm._e(), _vm._v(" "), (_vm.category == '4') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 product"
  }, [_c('div', {
    staticClass: "product-area"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpProduct('66')
      }
    }
  }, [_vm._v(" Barium Sulfate")])])])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product114_logo.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product115_logo.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product107_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product57_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product59_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product63_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product118_logo.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product61_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product60_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product71_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product96_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product69_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product117_logo.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product70_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product108_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product106_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product79_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product56_logo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "/static/images/product/product66_logo.png"
    }
  })])
}]}

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "left-title1"
  }, [_vm._v(_vm._s(_vm.$t('menu_product_left')))]), _vm._v(" "), _c('div', {
    staticClass: "left-panel1",
    staticStyle: {
      "border-top": "1px solid #e2e6eb"
    }
  }, [_c('div', [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('1')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('menu_product_1')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "left-panel1"
  }, [_c('div', [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('2')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('menu_product_2')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "left-panel1 panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "heading3"
    }
  }, [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('3')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('menu_product_3')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "left-panel1 panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "heading7"
    }
  }, [_c('div', {
    staticClass: "panel-title",
    on: {
      "click": function($event) {
        return _vm.jump('4')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('menu_product_4')))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "background": "#e1e1e1",
      "padding-left": "15px",
      "height": "50px",
      "line-height": "50px"
    }
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "heading6"
    }
  }, [_c('div', {
    staticClass: "panel-title",
    staticStyle: {
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('left_q_title')))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#f1f1f1",
      "padding": "0px 15px"
    }
  }, [_c('div', {
    staticClass: "sub-panel1",
    on: {
      "click": function($event) {
        return _vm.jump1()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('left_q_1')))]), _vm._v(" "), _c('div', {
    staticClass: "sub-panel1",
    on: {
      "click": function($event) {
        return _vm.jump1()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('left_q_2')))]), _vm._v(" "), _c('div', {
    staticClass: "sub-panel1",
    on: {
      "click": function($event) {
        return _vm.jump1()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('left_q_3')))]), _vm._v(" "), _c('div', {
    staticClass: "sub-panel1",
    on: {
      "click": function($event) {
        return _vm.jump1()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('left_q_4')))]), _vm._v(" "), _c('div', {
    staticClass: "sub-panel1",
    staticStyle: {
      "border": "none"
    },
    on: {
      "click": function($event) {
        return _vm.jump1()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('left_q_5')))])])])
},staticRenderFns: []}

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - ABOUT US - COMPANY")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "30px 0px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "color": "#333",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('p', [_vm._v("\n                ADA Chemical is a professional manufacture of chemical raw materials. Our sales and service center is in Shanghai, and our production base is located in Zibo City, Shandong Province, which is well-known as the supper-large chemical city in China.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('p', [_vm._v("\n            Established in 1995, we have more than 20 years 'experience in chemical industry. Now the company has an asset of over 30,000,000RMB, covers 10,000 square meters, and we have more than 120 employees now.\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('p', [_vm._v("\n            After 20 years’ technology accumulation and market development, we are now dedicated in the following products:\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('ul', [_c('li', [_vm._v("\n                Aluminum hydroxide:  We are producing different particle size of ATH，our superfine model is up to 1um, the main applications are for flame retardant, solid surface, glass, alum, etc.")]), _c('li', [_vm._v("\n                PVC raw materials: We can supply full series of PVC materials, such as PVC Resin, PVC Stabilizer, CPE, blowing agent, lubricant, plasticizer, pigments, etc. Not only supply all these materials, we can also provide technical support for our customers during their production.")]), _c('li', [_vm._v("\n                Boron Nitride: Our Boron Nitride products are price competitive and high quality, we can provide both powders and coating. It is mainly used in precision molding, high temperature resistant, structural material, etc.")]), _c('li', [_vm._v("\n                Raw materials: Such as Purified Terephthalic acid (PTA), HPMC&CMC, HDPE&LDPE, Dicyandiamide, Melamine, etc.")]), _c('li', [_vm._v("\n                Food additives: Sodium bicarbonate, sodium acid pyrophosphate, ammonium bicarbonate, etc.")])]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('p', [_vm._v("\n                We believe that our factory direct prices will low down your cost and help you to grow your business. All staff of ADA Chemicals warmly welcome customers and friends all over the world.\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                爱代化工是一家化工原材料专业生产厂家，我们的生产基地座落在山东省淄博市，并在上海设有销售和服务中心。爱代化工成立于1995年，有着20多年的化工行业经验。公司生产基地占地面积约10000平方米，现有员工120多名。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                公司主要产品有氢氧化铝，氮化硼，PVC添加剂等，广泛应用于PVC、橡胶、建材、电子、水处理等多个领域。公司产品品质优异，部分产品可直接替代进口原料，并长期出口东南亚、中东、及欧美的多个国家和地区。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                经过20多年的积累，公司不但拥有独立的生产设备，也配备了精密的测试仪器。公司培训了一批高素质的员工队伍，确保本公司的产品质量更加稳固可靠。我们的技术专家和客户服务人员致力于提供最优质的服务，帮助您找到合适的原材料，并为您产品测试、应用、落地等提供全套的技术支持和售后保障。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                我们致力于用更优良的产品质量和服务来满足客户的要求。 “科技为本、诚信经营”是公司一贯恪守的宗旨。稳步发展、与时俱进。公司期待与国内外新老客户真诚合作，共赢未来！\n\n            ")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "box-shadow": "0px 0px 10px #aaa"
    },
    attrs: {
      "src": "/static/images/about-us-company.jpg"
    }
  })])
}]}

/***/ }),

/***/ 424:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - ABOUT US - CUSTOMER")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "30px 0px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "color": "#333",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('customer_1')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('customer_2')) + "\n            ")]), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('p', [_vm._v("\n            Pre-Sales service：\n            "), (_vm.$i18n.locale == 'en') ? _c('ul', [_c('li', [_vm._v("\nFree consulting service help you to find the most suitable material for your application.")]), _c('li', [_vm._v("\nProvide free sample for test and evaluation.")]), _c('li', [_vm._v("\nConsulting service through your testing process.")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('p', [_vm._v("\n            After-Sales service：\n            "), (_vm.$i18n.locale == 'en') ? _c('ul', [_c('li', [_vm._v("\nFast delivery and strict quality inspection for every shipment.")]), _c('li', [_vm._v("\nVarious packing available upon customer’s requirement.")]), _c('li', [_vm._v("\nProfessional service for shipment and export process.")]), _c('li', [_vm._v("\nTechnical support through your manufacturing process.")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                爱代化工是一家化工原材料专业生产厂家，我们的生产基地座落在山东省淄博市，并在上海设有销售和服务中心。爱代化工成立于1995年，有着20多年的化工行业经验。公司生产基地占地面积约10000平方米，现有员工120多名。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                公司主要产品有氢氧化铝，氮化硼，PVC添加剂等，广泛应用于PVC、橡胶、建材、电子、水处理等多个领域。公司产品品质优异，部分产品可直接替代进口原料，并长期出口东南亚、中东、及欧美的多个国家和地区。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                经过20多年的积累，公司不但拥有独立的生产设备，也配备了精密的测试仪器。公司培训了一批高素质的员工队伍，确保本公司的产品质量更加稳固可靠。我们的技术专家和客户服务人员致力于提供最优质的服务，帮助您找到合适的原材料，并为您产品测试、应用、落地等提供全套的技术支持和售后保障。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                我们致力于用更优良的产品质量和服务来满足客户的要求。 “科技为本、诚信经营”是公司一贯恪守的宗旨。稳步发展、与时俱进。公司期待与国内外新老客户真诚合作，共赢未来！\n\n            ")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "box-shadow": "0px 0px 10px #aaa"
    },
    attrs: {
      "src": "/static/images/about-us-customer.jpeg"
    }
  })])
}]}

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - SERVICE")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "30px 0px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "color": "#333",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('service_title_1')) + "            ")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('service_title_2')) + "       \n            ")]), _vm._v(" "), _c('div', [_c('li', [_vm._v(_vm._s(_vm.$t('service_q_1')) + "       ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('service_a_1')) + "  ")]), _vm._v(" "), _c('div', [_c('li', [_vm._v(_vm._s(_vm.$t('service_q_2')) + "       ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('service_a_2')) + "  ")]), _vm._v(" "), _c('div', [_c('li', [_vm._v(_vm._s(_vm.$t('service_q_3')) + "       ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('service_a_3')) + "  ")]), _vm._v(" "), _c('div', [_c('li', [_vm._v(_vm._s(_vm.$t('service_q_4')) + "       ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('service_a_4')) + "  ")]), _vm._v(" "), _c('div', [_c('li', [_vm._v(_vm._s(_vm.$t('service_q_5')) + "       ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('service_a_5')) + "  ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "box-shadow": "0px 0px 10px #aaa"
    },
    attrs: {
      "src": "/static/images/service.jpeg"
    }
  })])
}]}

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - ABOUT US - TEAM")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "30px 0px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "color": "#333",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('team_1')) + "            ")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('team_2')) + "             ")]), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                爱代化工是一家化工原材料专业生产厂家，我们的生产基地座落在山东省淄博市，并在上海设有销售和服务中心。爱代化工成立于1995年，有着20多年的化工行业经验。公司生产基地占地面积约10000平方米，现有员工120多名。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                公司主要产品有氢氧化铝，氮化硼，PVC添加剂等，广泛应用于PVC、橡胶、建材、电子、水处理等多个领域。公司产品品质优异，部分产品可直接替代进口原料，并长期出口东南亚、中东、及欧美的多个国家和地区。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                经过20多年的积累，公司不但拥有独立的生产设备，也配备了精密的测试仪器。公司培训了一批高素质的员工队伍，确保本公司的产品质量更加稳固可靠。我们的技术专家和客户服务人员致力于提供最优质的服务，帮助您找到合适的原材料，并为您产品测试、应用、落地等提供全套的技术支持和售后保障。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                我们致力于用更优良的产品质量和服务来满足客户的要求。 “科技为本、诚信经营”是公司一贯恪守的宗旨。稳步发展、与时俱进。公司期待与国内外新老客户真诚合作，共赢未来！\n\n            ")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "box-shadow": "0px 0px 10px #aaa"
    },
    attrs: {
      "src": "/static/images/about-us-team.jpeg"
    }
  })])
}]}

/***/ }),

/***/ 427:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - PRODUCT - " + _vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [(_vm.id == '1140' || _vm.id == '1141' || _vm.id == '1142') ? _c('img', {
    staticStyle: {
      "width": "90%",
      "box-shadow": "0px 0px 10px #ddd",
      "border-radius": "3px"
    },
    attrs: {
      "src": "/static/images/product/product114_logo.jpg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.id == '114') ? _c('img', {
    staticStyle: {
      "width": "90%",
      "box-shadow": "0px 0px 10px #ddd",
      "border-radius": "3px"
    },
    attrs: {
      "src": "/static/images/product/product114_logo.jpg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.id == '118') ? _c('img', {
    staticStyle: {
      "width": "90%",
      "box-shadow": "0px 0px 10px #ddd",
      "border-radius": "3px"
    },
    attrs: {
      "src": "/static/images/product/product118_logo.jpg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.id == '115' || _vm.id == '1151') ? _c('img', {
    staticStyle: {
      "width": "90%",
      "box-shadow": "0px 0px 10px #ddd",
      "border-radius": "3px"
    },
    attrs: {
      "src": "/static/images/product/product115_logo.jpg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.id == '117') ? _c('img', {
    staticStyle: {
      "width": "90%",
      "box-shadow": "0px 0px 10px #ddd",
      "border-radius": "3px"
    },
    attrs: {
      "src": "/static/images/product/product117_logo.jpg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.id != '1142' && _vm.id != '1141' && _vm.id != '1140' && _vm.id != '117' && _vm.id != '114' && _vm.id != '118' && _vm.id != '115' && _vm.id != '1151') ? _c('img', {
    staticStyle: {
      "width": "90%",
      "box-shadow": "0px 0px 10px #ddd",
      "border-radius": "3px"
    },
    attrs: {
      "src": '/static/images/product/product' + _vm.id + '_logo.png'
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('h2', {
    staticClass: "text-primary",
    staticStyle: {
      "color": "#526193 !important"
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', [(_vm.id == '1140' || _vm.id == '1141' || _vm.id == '1142' || _vm.id == '114') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_1')) + ":  ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_2')) + ":")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("21645-51-2")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_3')) + ":")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_8')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_4')) + ": ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("281830000")])])])]) : _vm._e(), _vm._v(" "), (_vm.id == '56') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_6')) + ":  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_10')))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_7')) + ":")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("70-120 ℃")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_3')) + ":")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_9')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_4')) + ": ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("38123090")])])])]) : _vm._e(), _vm._v(" "), (_vm.id == '66') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.id == '63') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.id == '118') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.id == '117') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.id == '108') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.id == '70') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(7)]) : _vm._e(), _vm._v(" "), (_vm.id == '79') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(8)]) : _vm._e(), _vm._v(" "), (_vm.id == '59') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(9)]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_5')) + ": ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v(_vm._s(_vm.$t('home_product_section_2')))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_1')) + ":  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("BN")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_2')) + ":")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("10043-11-5")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_3')) + ":")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_8')))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('product_4')) + ": ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("2850001900")])])])]) : _vm._e(), _vm._v(" "), (_vm.id == '69') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(10)]) : _vm._e(), _vm._v(" "), (_vm.id == '107') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(11)]) : _vm._e(), _vm._v(" "), (_vm.id == '106') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(12)]) : _vm._e(), _vm._v(" "), (_vm.id == '60') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(13)]) : _vm._e(), _vm._v(" "), (_vm.id == '61') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(14)]) : _vm._e(), _vm._v(" "), (_vm.id == '96') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(15)]) : _vm._e(), _vm._v(" "), (_vm.id == '71') ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(16)]) : _vm._e()])])]), _vm._v(" "), (_vm.id != '1142' && _vm.id != '114' && _vm.id != '571' && _vm.id != '1151' && _vm.id != '115' && _vm.id != '57') ? _c('div', {
    staticClass: "product-sub",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("\n                    Technical Details\n                ")]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.id == '1140') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(17)]) : _vm._e(), _vm._v(" "), (_vm.id == '1141') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(18)]) : _vm._e(), _vm._v(" "), (_vm.id == '56') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(19)]) : _vm._e(), _vm._v(" "), (_vm.id == '106') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(20)]) : _vm._e(), _vm._v(" "), (_vm.id == '107') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(21)]) : _vm._e(), _vm._v(" "), (_vm.id == '59') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(22)]) : _vm._e(), _vm._v(" "), (_vm.id == '60') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(23)]) : _vm._e(), _vm._v(" "), (_vm.id == '96') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(24)]) : _vm._e(), _vm._v(" "), (_vm.id == '71') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(25)]) : _vm._e(), _vm._v(" "), (_vm.id == '66') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(26)]) : _vm._e(), _vm._v(" "), (_vm.id == '108') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(27)]) : _vm._e(), _vm._v(" "), (_vm.id == '70') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(28)]) : _vm._e(), _vm._v(" "), (_vm.id == '63') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(29)]) : _vm._e(), _vm._v(" "), (_vm.id == '69') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(30)]) : _vm._e(), _vm._v(" "), (_vm.id == '118') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(31)]) : _vm._e(), _vm._v(" "), (_vm.id == '117') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(32)]) : _vm._e(), _vm._v(" "), (_vm.id == '61') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(33)]) : _vm._e(), _vm._v(" "), (_vm.id == '79') ? _c('table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    }
  }, [_vm._m(34)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Properties\n                ")]), _vm._v(" "), (_vm.id == '1140' || _vm.id == '1141' || _vm.id == '1142' || _vm.id == '114') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_vm._m(35), _vm._v(" "), _c('p', [_vm._v("With 20 years production experience, now ADA Aluminum Hydroxide products have stable and high standard quality, with super fine particle size up to 1um, high whiteness up to 97, and also with low impurities. Now our ATH chemicals are exporting to more than 20 countries, and widely used in all kinds of industrial applications, such as fire retardants, artificial marbles, water treatment, and so on.\n")])]) : _vm._e(), _vm._v(" "), (_vm.id == '70') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Dicyandiamide is a kind of white crystal powder,which is soluble in water and alcohol, slightly insoluble in aether and benzene, stable when dry and not flammable.")]), _vm._v(" "), _c('p', [_vm._v("It is a material of melamine and intermediate pan of syntheticdrug,pesticides and coloring agent. It can be produced guanidine nitrate,sulfanilamide,sulfocarbanide,rubber accelerator,hardening of stell,fixing agent of dyeprinting,sizing agent,compound fertilizer,etc.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '69') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Sodium acid pyrophosphate, or disodium pyrophosphate, is an edible phosphoric salt that helps create leavening used for baking, such as baking powder, and prevents food discoloration, such as in raw potatoes.")]), _vm._v(" "), _c('p', [_vm._v("In its bulk state, such as at the manufacturing laboratory, the acidic nature of sodium acid pyrophosphate may be very hazardous upon skin or eye contact, inhalation or ingestion, causing severe inflammation.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '106') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Black Silicon Carbide, also know as Black SiC, is produced in an electric resistance furnace from quartz sand and petroleum coke or anthracite at high temperature. The hardness and sharp particle of this material make it suitable for manufacturing of grinding wheels, coated products, wire saws, superior refractory materials and deoxide as well as for lapping, polishing and blasting.")]), _vm._v(" "), _c('p', [_vm._v("We are professional manufacturer of Silicon Carbide, and we are producing different grade of Silicon Carbide for all kinds of industrial applications.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Hexagonal Boron Nitride is a thermally and chemically resistant refractory compound of boron and nitrogen with the chemical formula BN. The material is anisotropic for its electrical and mechanical properties due to the platy hexagonal crystals and their orientation during the hot press consolidation.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Boron Nitride has high thermal conductivity, low thermal expansion, good thermal shock resistance, high electrical resistance, low dielectric constant and loss tangent.\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.id == '117') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("It is an organic compound and is the most prolific dicarboxylic acid. Solid at room temperature. Heating will not melt, 300℃ above sublimation. If heated in an airtight container, it melts at 427℃. Terephthalic acid is the raw material for the production of polyesters, especially polyethylene terephthalate (PET).")]), _vm._v(" "), _c('p', [_vm._v("We are professional provider of PTA materials, and our sales specialist will recommend the most suitable material for your application, and related Technical Data Sheet is available upon your request.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '63') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Azodicarbonamide blowing agent is a kind of light yellow fine powder, which is one of the most widely used chemical blowing agents due to its non-toxic, odorless, self-extinguishing, relatively high decomposition temperature, and relatively large gas evolution properties, good dispersing in plastic and rubber.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '66') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Barium sulfate is a kind of amorphous white powder or paste. It is nontoxic, insoluble in water, and slightly soluble in boiling hydrochloric acid.")]), _vm._v(" "), _c('p', [_vm._v("It is chemically stable, with a total reduction of carbon as barium sulfide. It won't change color when meeting with hydrogen sulfide or toxic gases in the air.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '79') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("It is produced by the spray drying technology and the obtained product is light yellow, corresponding liquid form products is light yellow.")]), _vm._v(" "), _c('p', [_vm._v("It is a kind of high-efficient,economical and nontoxic inorganic high-molecular compound, which is easily soluble in water. And it's accompanied with many chemical processes such as electrochemistry,coagulation, absorption and precipitation during the hydrolyzation .")])]) : _vm._e(), _vm._v(" "), (_vm.id == '56') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Magnesium hydroxide is a white powder which is nontoxic, odorless, non-corrosion and with good flame retarding effect. It has good stability, decomposition temperature is about 330, especially suitable for resin processed in relative high temperature. Large amount of vapor is produced during combustion, the heat is taken away and the temperature drops. The hardness is less than that of aluminum hydroxide.")]), _vm._v(" "), _c('p', [_vm._v("According to different applications, we are offering a wide range types of magnesium hydroxide, with different particle size\\whiteness, and we can also offer natural grade or coated types as requested.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '107') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("It is a protection coating material used in metal casting equipment and equipment molds, which has good adhesion ability for metal or ceramic materials, and to provide the most effective lubrication and protection of the interface.")]), _vm._v(" "), _c('p', [_vm._v("Boron Nitride Coating is made by boron nitride materials by unique formula, which can achieve excellent performance in high temperature metal protection, effectively prevent the molten metal from corrosion, extend the service life of equipment and various tools, reduce the production cost.")]), _vm._v(" "), _c('p', [_vm._v("We are professional manufacturer of Boron Nitride coating materials, and we are producing different grade of products for all kinds of industrial applications.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '96') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Nano calcium carbonate is also called super fine calcium carbonate .It can provide some excellent functions during polymer production such as improving the hardness of the polymer, improving strength (tensile and impact) and enhancing the surface whiteness and gloss finish.")]), _vm._v(" "), _c('p', [_vm._v("At the same time, it can also greatly reduce the cost during the production of plastic and rubber products.")]), _vm._v(" "), _c('p', [_vm._v("With it's outstanding functions, nano calcium carbonate is widely used in plastics product such as cable, pipe, masterbatch, film, sheet, etc. And also used in Paint & coating,paper, water treatment, etc.")]), _vm._v(" "), _c('p', [_vm._v("We are professional manufacturer of Nano calcium carbonate powders, and we are producing different grade of Nano calcium carbonate for all kinds of industrial applications.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '108') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Fumed silica is an extremely small particle with enormous surface area, high purity, and a tendency to form chains in the chemical manufacturing process.")]), _vm._v(" "), _c('p', [_vm._v("Particles are formed by injecting chlorosilanes, such as silicon tetrachloride, into a flame of hydrogen and air. The ensuring reaction produces fumed silica and hydrogen chloride.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '118') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("It is white powder, and the particle size is 60-250um. It is fire retardant and self-extinguishing, with very good chemical resistance.\n                  ")]), _vm._v(" "), _c('p', [_vm._v("It is mainly used to produce soft plastic products such as artificial leather, films, and wire sheaths, as well as hard plastic products such as plates, doors and windows, pipes and valves.\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.id == '60') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Polyethylene wax is a widely used raw materials which has low adhesive, high softening point and good hardness with stable chemical characteristics.")]), _vm._v(" "), _c('p', [_vm._v("It also has good heat stability, good dispersion performance, no poison, no frost and mucous membrane.")]), _vm._v(" "), _c('p', [_vm._v("With all the above featues, it can be used as an ideal interior & exterior lubricant, and also as a substitute for liquid paraffin, natural paraffin etc.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '71') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Optical Brightener is a kind of light yellow powder, it is hardly soluble in water, but soluble in paraffin, mineral oils and ordinary organic solvents.")]), _vm._v(" "), _c('p', [_vm._v("There are different grade of optical brighteners such as OB grade/OB-1 grade/KSN grade /etc, each type of optical brightener can be used as good whitening agent for various application products such as plastic products, paintings, paper and textiles.\n\n")])]) : _vm._e(), _vm._v(" "), (_vm.id == '59') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("CPE resin is one kind of rubber high molecular material made of high-density polythene resin after chlorination reaction, which has good mechanical and chemical properties.")]), _vm._v(" "), _c('p', [_vm._v("It is widely used in PVC plastic profile, sheet, pipe, pipe fittings, waterproof membrane, wire and cable sheathing, sealing, PVC laminated and extension of various plastics and rubber products.")])]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("ADA PVC Stabilizers are combinations of chemical additives necessary for the production of various PVC products. The stabilizer is Lead or Ca-Zn based, and also combined with lubricants and other additives, which can achieve ideal performance both for production and final products.\n             ")]), _vm._v(" "), _c('p', [_vm._v("ADA provides different models of stabilizers for applications such as: Pipes & Fittings, Wires & Cables, Window Profiles, Flooring and Films. Please contact our sales staff, we will give more product information according to your specific technical requirements.\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.id == '61') ? _c('div', {
    staticStyle: {
      "color": "#666",
      "font-size": "14px",
      "line-height": "25px",
      "margin-top": "5px"
    }
  }, [_c('p', [_vm._v("Calcium Stearate is a kind of white fine powder, which is insoluble in water, soluble in hot ethanol and ether. It is easy to absorb, and will be decomposed to stearic acid and the relevant calcium-salt.")]), _vm._v(" "), _c('p', [_vm._v("It is mainly performed as a good kind of PVC lubricant, and widely used in PP and PVC products.")])]) : _vm._e(), _vm._v(" "), (_vm.id != '1142' && _vm.id != '114' && _vm.id != '571' && _vm.id != '1151' && _vm.id != '57' && _vm.id != '115') ? _c('div', {
    staticClass: "product-sub"
  }, [_c('span', [_vm._v("Main Applications")])]) : _vm._e(), _vm._v(" "), (_vm.id == '1142' || _vm.id == '114') ? _c('div', {
    staticClass: "product-sub"
  }, [_c('span', [_vm._v("Technical Details")])]) : _vm._e(), _vm._v(" "), (_vm.id != '1141' && _vm.id != '1140' && _vm.id != '57' && _vm.id != '115' && _vm.id != '114' && _vm.id != '1142' && _vm.id != '571' && _vm.id != '1151') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": '/static/images/product/product' + _vm.id + '_1.png'
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.id == '1141') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(36), _vm._v(" "), _c('div', {
    staticClass: "row big"
  }, [_vm._m(37), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": '/static/images/product/p1141_right.png'
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.id == '1140') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(38), _vm._v(" "), _vm._m(39)]) : _vm._e(), _vm._v(" "), (_vm.id == '1142' || _vm.id == '114') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(40), _vm._v(" "), _vm._m(41)]) : _vm._e(), _vm._v(" "), (_vm.id != '571' && _vm.id != '1151' && _vm.id != '57' && _vm.id != '115') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Packing & Delivery\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id != '1141' && _vm.id != '114' && _vm.id != '1140' && _vm.id != '115' && _vm.id != '1142' && _vm.id != '57' && _vm.id != '571' && _vm.id != '1151') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": '/static/images/product/product' + _vm.id + '_2.png'
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.id == '1142' || _vm.id == '114') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(42), _vm._v(" "), _vm._m(43)]) : _vm._e(), _vm._v(" "), (_vm.id == '1141') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(44), _vm._v(" "), _c('div', {
    staticClass: "row big"
  }, [_vm._m(45), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": '/static/images/product/p1141_right_2.png'
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.id == '1140') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(46), _vm._v(" "), _vm._m(47)]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Product Details\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(48), _vm._v(" "), _vm._m(49)]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Technical Support\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(50), _vm._v(" "), _vm._m(51)]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    One-Stop Provider\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id == '571' || _vm.id == '57') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(52), _vm._v(" "), _vm._m(53)]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Technical Details\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(54), _vm._v(" "), _vm._m(55)]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Particle Distribution\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(56), _vm._v(" "), _vm._m(57)]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Main Applications\n                ")]) : _vm._e(), _vm._v(" "), (_vm.id == '1151' || _vm.id == '115') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "5px"
    }
  }, [_vm._m(58), _vm._v(" "), _vm._m(59)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product-sub"
  }, [_vm._v("\n                    Sales Contact\n                ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._m(60), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 order-md-1 aos-init aos-animate",
    staticStyle: {
      "font-size": "13px !important"
    }
  }, [_c('contact', {
    attrs: {
      "productName": _vm.name
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Al(OH)"), _c('sub', [_vm._v("3")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Mg(oh)2")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("1309-48-4")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("96% min")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("BaSO4")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("7727-43-7")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("HS Code: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("2833270000")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("C2H4N4O2")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("123-77-3")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Pale yellow powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("CH2-CHCLn")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("9002-86-2")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("HS Code:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("39041000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("C8H6O4")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("100-21-0")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("EINECS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("202-830-0")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("SiO2")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("112945-52-5")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White Powder ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99.8%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("C2H4N4")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("461-58-5")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("EINECS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("207-312-8")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White crystal powder")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("[AL2(OH)LnCL6-n]m")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("1327-41-9")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("EINECS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("215-477-2")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Yellow powder")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("[CH2-CHCl-CH2-CH2]n")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("63231-66-3")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99.9%")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White powder")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Na2H2P2O7")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("7758-16-9")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("EINECS: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("231-835-0")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Chemical name:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Boron Nitride Coating")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Packing:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Barrels")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White emulsion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Solid content: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("25% ~ 30%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Chemical name:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Black Silicon Carbide")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("SiC")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Black Granula")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Application: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Abrasive")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("(C2H4)n")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("9002-88-4")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White flake")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Softening Point (℃): ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("100-110")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("C36H70O4Ca")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("1592-23-0")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99.9%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("CAS No.:  ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("471-34-1")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("MF:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("CACO3")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("White powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99% min")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticStyle: {
      "font-size": "14px",
      "color": "#666",
      "width": "320px"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Melting point: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("205-360°C")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Particle size:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("300 meshes Min")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f5f5f5",
      "border-bottom": "1px solid #eee"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Appearance:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("Light yellow powder")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Purity: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "5px 10px",
      "color": "#526193"
    }
  }, [_vm._v("99% min")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_c('strong', [_vm._v("Category")])]), _c('td', [_c('strong', [_vm._v("Model")])]), _c('td', [_c('strong', [_vm._v("Content（%）")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Particle size（D50）")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Whiteness")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Moisture（%）")])])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Fine Grade")]), _vm._v(" "), _c('td', [_vm._v("AF-1")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("1-2 um")]), _vm._v(" "), _c('td', [_vm._v("96")]), _vm._v(" "), _c('td', [_vm._v("≤0.25")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("AF-4")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("3-5 um")]), _vm._v(" "), _c('td', [_vm._v("93-97")]), _vm._v(" "), _c('td', [_vm._v("≤0.22")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AF-8")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("8-10 um")]), _vm._v(" "), _c('td', [_vm._v("93-97")]), _vm._v(" "), _c('td', [_vm._v("≤0.20")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("High Whiteness")]), _vm._v(" "), _c('td', [_vm._v("AH-14")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("14 um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.30")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AH-25")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("25 um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.20")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("AH-50")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("50 um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.15")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AH-75")]), _vm._v(" "), _c('td', [_vm._v("≥99.6")]), _vm._v(" "), _c('td', [_vm._v("75 um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.15")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Normal Grade")]), _vm._v(" "), _c('td', [_vm._v("AN-W")]), _vm._v(" "), _c('td', [_vm._v("≥99.5")]), _vm._v(" "), _c('td', [_vm._v("70-90 um")]), _vm._v(" "), _c('td', [_vm._v("89")]), _vm._v(" "), _c('td', [_vm._v("3-5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AN-D")]), _vm._v(" "), _c('td', [_vm._v("≥99.5")]), _vm._v(" "), _c('td', [_vm._v("70-90 um")]), _vm._v(" "), _c('td', [_vm._v("89")]), _vm._v(" "), _c('td', [_vm._v("≤0.35")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_c('strong', [_vm._v("Category")])]), _c('td', [_c('strong', [_vm._v("Model")])]), _c('td', [_c('strong', [_vm._v("Content")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Particle size")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Whiteness")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Moisture")])])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_c('strong', [_vm._v("Fine Grade")])]), _vm._v(" "), _c('td', [_vm._v("AF-1")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("1-2um")]), _vm._v(" "), _c('td', [_vm._v("96")]), _vm._v(" "), _c('td', [_vm._v("≤0.25%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("AF-4")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("3-5um")]), _vm._v(" "), _c('td', [_vm._v("93-97")]), _vm._v(" "), _c('td', [_vm._v("≤0.22%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AF-8")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("8-10um")]), _vm._v(" "), _c('td', [_vm._v("93-97")]), _vm._v(" "), _c('td', [_vm._v("≤0.20%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "rowspan": "4"
    }
  }, [_c('strong', [_vm._v("High Whiteness")])]), _vm._v(" "), _c('td', [_vm._v("AH-14")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("14um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.30%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AH-25")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("25um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.20%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("AH-50")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("50um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.15%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AH-75")]), _vm._v(" "), _c('td', [_vm._v("≥99.6%")]), _vm._v(" "), _c('td', [_vm._v("75um")]), _vm._v(" "), _c('td', [_vm._v("97")]), _vm._v(" "), _c('td', [_vm._v("≤0.15%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_c('strong', [_vm._v("Normal Grade")])]), _vm._v(" "), _c('td', [_vm._v("AN-W")]), _vm._v(" "), _c('td', [_vm._v("≥99.5%")]), _vm._v(" "), _c('td', [_vm._v("70-90um")]), _vm._v(" "), _c('td', [_vm._v("89")]), _vm._v(" "), _c('td', [_vm._v("3-5%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("AN-D")]), _vm._v(" "), _c('td', [_vm._v("≥99.5%")]), _vm._v(" "), _c('td', [_vm._v("70-90um")]), _vm._v(" "), _c('td', [_vm._v("89")]), _vm._v(" "), _c('td', [_vm._v("≤0.35%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical Value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Mg(OH)2 , %")]), _c('td', [_vm._v("≥94")]), _c('td', [_vm._v("96.3")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Particle Size")]), _c('td', [_vm._v("325-8000 Mesh")]), _c('td', [_vm._v("325-8000 Mesh")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Whiteness")]), _c('td', [_vm._v("≥91")]), _c('td', [_vm._v("93")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("CaO , %")]), _c('td', [_vm._v("≤ 2.0")]), _c('td', [_vm._v("0.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Hydrochloric acid insoluble，% ")]), _c('td', [_vm._v("≤ 2.0")]), _c('td', [_vm._v("0.8")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Moisture，%")]), _c('td', [_vm._v("≤ 0.5")]), _c('td', [_vm._v("0.17")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Cl， %")]), _c('td', [_vm._v("≤ 0.05")]), _c('td', [_vm._v("0")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Fe， %")]), _c('td', [_vm._v("≤ 1.0")]), _c('td', [_vm._v("0.1")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("75um Residue, %")]), _c('td', [_vm._v("≤ 0.01")]), _c('td', [_vm._v("0")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Loss on ignition，%")]), _c('td', [_vm._v("≥28")]), _c('td', [_vm._v("30")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Modification Rate, %")]), _c('td', [_vm._v("≥98")]), _c('td', [_vm._v("99.5")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Appearance")]), _c('td', [_vm._v("Black granular")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Hardness, Mohs")]), _c('td', [_vm._v(">6")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Apparent density ,kg/M3")]), _c('td', [_vm._v("3.2 x 10³")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Moisture,%")]), _c('td', [_vm._v("0.01")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("SiO2,%")]), _c('td', [_vm._v("28")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Al2O3,%")]), _c('td', [_vm._v("9.29")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Fe2O3,%")]), _c('td', [_vm._v("22.1")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("MgO,%")]), _c('td', [_vm._v("4.62")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("C")]), _c('td', [_vm._v("16.3")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Particle Size (Mesh)")]), _c('td', [_vm._v("10-20, 20-40, 20-60, or as customer required")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Main ingredients")]), _c('td', [_vm._v("Hexagonal boron nitride")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Coverage area")]), _c('td', [_vm._v("25-30m2/L")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Adhesive")]), _c('td', [_vm._v("Clay")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Viscosity")]), _c('td', [_vm._v("4000-5000CPS")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Specific gravity")]), _c('td', [_vm._v("1.2(g/㎝3)")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Solid content")]), _c('td', [_vm._v("25%~30%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Appearance")]), _c('td', [_vm._v("White emulsion")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Chlorine content, %")]), _c('td', [_vm._v("35±2")]), _c('td', [_vm._v("35.8")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Heat of fusion, j/g")]), _c('td', [_vm._v("≤2.0")]), _c('td', [_vm._v("1.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Volatile matter %")]), _c('td', [_vm._v("≤0.4")]), _c('td', [_vm._v("0.17")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Residue on sieve (mesh of 0.9mm)  %")]), _c('td', [_vm._v("≤2.0")]), _c('td', [_vm._v("0.6")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Impurity particles, pc/100g")]), _c('td', [_vm._v("≤60")]), _c('td', [_vm._v("21")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Tensile strength, Mpa")]), _c('td', [_vm._v("≥8.0")]), _c('td', [_vm._v("9")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Shore hardness")]), _c('td', [_vm._v("≤65")]), _c('td', [_vm._v("52")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Appearance")]), _c('td', [_vm._v("White flake")]), _c('td', [_vm._v("White flake")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Softening point ℃")]), _c('td', [_vm._v("90-105")]), _c('td', [_vm._v("100")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Dosage (%)")]), _c('td'), _c('td', [_vm._v("3.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Density (g/cm3)")]), _c('td', [_vm._v("0.90-0.93")]), _c('td', [_vm._v("0.91")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Average molecular weight")]), _c('td', [_vm._v("2000-2500")]), _c('td', [_vm._v("2320")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("calcium carbonate,%")]), _c('td', [_vm._v("≥ 98")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("PH value")]), _c('td', [_vm._v("8.0-10.0")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Moisture,%")]), _c('td', [_vm._v("≤0.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Whiteness")]), _c('td', [_vm._v(" ≥ 96")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Particle size")]), _c('td', [_vm._v("20-110 nm")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Fe content, %")]), _c('td', [_vm._v("≤0.08")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Mn content, %    ")]), _c('td', [_vm._v(" ≤0.006")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Surface treatment")]), _c('td', [_vm._v("stearic acid")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Oil absorption ml/100g ")]), _c('td', [_vm._v("≤35")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("E (1% /cm)         ")]), _c('td', [_vm._v("420-1200")]), _c('td', [_vm._v("420-1200(Depends on grade)")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Indissoluble substance:       ")]), _c('td', [_vm._v("0.5%max")]), _c('td', [_vm._v("0.35")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Solubility in water (25℃, g/l )")]), _c('td', [_vm._v("20-30")]), _c('td', [_vm._v("25")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Solubility in water   (70℃, g/l )")]), _c('td', [_vm._v("90-110")]), _c('td', [_vm._v("100")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Solubility in water ( (95℃, g/l ))")]), _c('td', [_vm._v("290-310")]), _c('td', [_vm._v("300")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Max in ultra-violet range")]), _c('td', [_vm._v("348-350nm")]), _c('td', [_vm._v("349 nm")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standards")]), _c('td', [_vm._v("Typical Value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Content")]), _c('td', [_vm._v("≥98.0%")]), _c('td', [_vm._v("0.982")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Water soluble matter")]), _c('td', [_vm._v("≤0.30%")]), _c('td', [_vm._v("0.0011")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Acid soluble matter")]), _c('td', [_vm._v("≤0.60%")]), _c('td', [_vm._v("confirmed")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("PH value  ")]), _c('td', [_vm._v("6.0-9.0")]), _c('td', [_vm._v("8")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Iron(Fe)")]), _c('td', [_vm._v("≤0.004%")]), _c('td', [_vm._v("4E-05")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Sulfide(S)")]), _c('td', [_vm._v("≤0.003%")]), _c('td', [_vm._v("1.5E-05")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Particle size distribution")]), _c('td', [_vm._v("Depends on grade")]), _c('td', [_vm._v("Depends on grade")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Oil absorption")]), _c('td', [_vm._v("8-25%")]), _c('td', [_vm._v("0.19")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Whiteness ")]), _c('td', [_vm._v("≥96")]), _c('td', [_vm._v("96")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Silica content(based on ignited material) ,wt%")]), _c('td', [_vm._v(">99.8%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Specific surface area (BET), m2/g   ")]), _c('td', [_vm._v("200+-15")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Carbon content(Based on drying at 105℃ for 2 hours) ,wt%")]), _c('td', [_vm._v("<0.15")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("PH-value in 4% dispersion")]), _c('td', [_vm._v("3.7-4.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Moisture loss on drying 2 hour at 105℃, wt%")]), _c('td', [_vm._v("<1.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Ignition loss 2 hours at 1000℃ based on material dried for 2 hours at 105℃, wt%")]), _c('td', [_vm._v("<2.0")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Sieve residue(45um), wt%")]), _c('td', [_vm._v("<0.04")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Tamped Density(Based on drying at 105℃ for 2 hours) ,g/L")]), _c('td', [_vm._v("40-60")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical Value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("C2H4N4 Content, %")]), _c('td', [_vm._v("≥99.5")]), _c('td', [_vm._v("99.6")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("H2O Content, %")]), _c('td', [_vm._v("≤0.30")]), _c('td', [_vm._v("0.22")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Ash Content, %")]), _c('td', [_vm._v("≤0.03")]), _c('td', [_vm._v("0.024")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("M.P. (°C)")]), _c('td', [_vm._v("209-212")]), _c('td', [_vm._v("210")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Ca Content (ppm)")]), _c('td', [_vm._v("≤200")]), _c('td', [_vm._v("95")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Appearance")]), _c('td', [_vm._v("Yellow powder")]), _c('td', [_vm._v("Yellow powder")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Gas of foaming amount(ML/G)")]), _c('td', [_vm._v("150-240")]), _c('td', [_vm._v("150-240")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Average diameter(um)")]), _c('td', [_vm._v("8.5-10")]), _c('td', [_vm._v("9")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Decomposition temperature,")]), _c('td', [_vm._v("150-220")]), _c('td', [_vm._v("150-220")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Moisture content(%)")]), _c('td', [_vm._v("0.5 max")]), _c('td', [_vm._v("0.12")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("PH")]), _c('td'), _c('td', [_vm._v("6.7")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Ash(%)")]), _c('td', [_vm._v("0.2 max")]), _c('td', [_vm._v("0.09")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Specification")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Appearance")]), _c('td', [_vm._v("White Powder")]), _c('td', [_vm._v("White Powder")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Content, %")]), _c('td', [_vm._v("≥95")]), _c('td', [_vm._v("95.33")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("PH of 1% water solution")]), _c('td', [_vm._v("3.5-5")]), _c('td', [_vm._v("3.98")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Water insoluble, %")]), _c('td', [_vm._v("≤1.0")]), _c('td', [_vm._v("0.03")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Pb, %")]), _c('td', [_vm._v("≤0.0015")]), _c('td', [_vm._v("0.001")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("As, %")]), _c('td', [_vm._v("≤0.0003")]), _c('td', [_vm._v("0.00018")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("F, %")]), _c('td', [_vm._v("≤0.005")]), _c('td', [_vm._v("0.002")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("P2O5, %")]), _c('td'), _c('td', [_vm._v("63.57")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Dryingloss %≤")]), _c('td'), _c('td', [_vm._v("0.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Bulk density")]), _c('td'), _c('td', [_vm._v("0.85")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Suspension Grade")]), _vm._v(" "), _c('td', [_vm._v("SG3")]), _vm._v(" "), _c('td', [_vm._v("SG4")]), _vm._v(" "), _c('td', [_vm._v("SG5")]), _vm._v(" "), _c('td', [_vm._v("SG6")]), _vm._v(" "), _c('td', [_vm._v("SG7")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("K value ")]), _c('td', [_vm._v("72-71")]), _c('td', [_vm._v("70-69")]), _c('td', [_vm._v("68-66")]), _c('td', [_vm._v("65-63")]), _c('td', [_vm._v("62-60")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Viscosity, ml/g ")]), _c('td', [_vm._v("135-127")]), _c('td', [_vm._v("126-119")]), _c('td', [_vm._v("118-107")]), _c('td', [_vm._v("106-96")]), _c('td', [_vm._v("95-87")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Average polymerization")]), _c('td', [_vm._v("1350-1250")]), _c('td', [_vm._v("1250-1150")]), _c('td', [_vm._v("1100-1000")]), _c('td', [_vm._v("950-850")]), _c('td', [_vm._v("950-850")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Number of impurity particle ≤")]), _c('td', [_vm._v(" 30")]), _c('td', [_vm._v(" 30")]), _c('td', [_vm._v(" 30")]), _c('td', [_vm._v(" 30")]), _c('td', [_vm._v(" 40")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Volatiles content %, ≤")]), _c('td', [_vm._v(" 0.40")]), _c('td', [_vm._v(" 0.40")]), _c('td', [_vm._v(" 0.40")]), _c('td', [_vm._v(" 0.40")]), _c('td', [_vm._v(" 0.40")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Spontaneous ignition point")]), _c('td', [_vm._v("680℃")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Burning point")]), _c('td', [_vm._v("384~421℃")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Sublimation fever")]), _c('td', [_vm._v("98.4kJ/mol")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Heat of combustion")]), _c('td', [_vm._v("3225.9kJ/mol")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Density")]), _c('td', [_vm._v("1.55g/cm3")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Item")]), _c('td', [_vm._v("Standard")]), _c('td', [_vm._v("Typical value")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Calcium content, %")]), _c('td', [_vm._v("6.0-7.1")]), _c('td', [_vm._v("6.6")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Moisture, %")]), _c('td', [_vm._v("3max")]), _c('td', [_vm._v("2.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Melting Point,°C")]), _c('td', [_vm._v("140 min")]), _c('td', [_vm._v("147")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Fineness (through mesh200), %")]), _c('td', [_vm._v("95min")]), _c('td', [_vm._v("98.5")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Free fatty acid, %")]), _c('td', [_vm._v("0.5 Max")]), _c('td', [_vm._v("0.4")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', {
    staticClass: "model-row",
    staticStyle: {
      "color": "white",
      "background": "#526193"
    }
  }, [_c('td', [_vm._v("Items")]), _c('td', [_vm._v("Specifications")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Aluminium oxide(Al2O3) % ")]), _c('td', [_vm._v("30%min")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Basicity%")]), _c('td', [_vm._v("70-90%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("PH (1% aqueous solution)")]), _c('td', [_vm._v("3.5-5.0%")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Water insoluble %")]), _c('td', [_vm._v("0.001")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("(As)/%")]), _c('td', [_vm._v("≤0.0002")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("(Pb)/%")]), _c('td', [_vm._v("≤0.001")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("Cd(Cd)/%")]), _c('td', [_vm._v("≤0.0002")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row"
  }, [_c('td', [_vm._v("Cr+6 %")]), _c('td', [_vm._v("≤0.0005")])]), _vm._v(" "), _c('tr', {
    staticClass: "model-row even"
  }, [_c('td', [_vm._v("   Hg %")]), _c('td', [_vm._v("≤0.00001")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Aluminum Hydroxide, Al(OH)"), _c('sub', [_vm._v("3")]), _vm._v(" ,also called alumina trihydrate. It has both basic and acidic properties, and closely related are aluminum oxide or alumina (Al"), _c('sub', [_vm._v("2")]), _vm._v("O"), _c('sub', [_vm._v("3")]), _vm._v("), It can be heated to 200°C and hydrated alumina can be decomposed into 66% alumina and 34% water.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1141_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-7",
    staticStyle: {
      "text-align": "left",
      "font-weight": "normal",
      "color": "#666"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "margin-top": "10px"
    }
  }, [_vm._v("Flame Retardant")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Used as flame retardant filler for PVC and Rubber products, such as wire, cable, construction material, paint, etc.\n                            ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Artificial Marble Filler")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Used as fillers for the production of Artificial Marble, Solid Surface, Stone, etc.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Raw Material")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Used as the raw material for the production of Alum, Glass, Water Treatment, etc.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1141_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1141_1_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_1_m.png"
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_2_m.png"
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_3_m.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_1.png"
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_2.png"
    }
  })]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_3.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_packing_m.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1142_packing.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1141_2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-7",
    staticStyle: {
      "text-align": "left",
      "font-weight": "normal",
      "color": "#666"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "margin-top": "10px"
    }
  }, [_vm._v("Packing")]), _vm._v(" "), _c('p'), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("25kg,  50kg, 1000Kg bags")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("OEM packing service available")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Loading")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("One 20ft container can load")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("- 14 Tons (Super fine grade)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("- 24 Tons (Other grades)")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Shipment")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Fast production and delivery.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Professional worldwide shipment")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1141_2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1141_2_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p571_1_m.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p571_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p571_2_m.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p571_2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p571_3_m.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p571_3.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1151_1_m.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1151_1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1151_2_m.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1151_2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1151_3_m.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row big"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/product/p1151_3.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-md-6 order-md-2",
    staticStyle: {
      "font-size": "15px",
      "line-height": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('i', {
    staticClass: "bi bi-envelope-fill",
    staticStyle: {
      "color": "#526193",
      "margin-right": "5px"
    }
  }), _vm._v("\n                      cliff@adachemicals.com")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('i', {
    staticClass: "bi bi-telephone-fill",
    staticStyle: {
      "color": "#526193",
      "margin-right": "5px"
    }
  }), _vm._v("\n                     +86-13917648345 "), _c('span', {
    staticStyle: {
      "margin-left": "3px"
    }
  }, [_vm._v("(WhatsApp/WeChat)")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('i', {
    staticClass: "bi bi-geo-alt-fill",
    staticStyle: {
      "color": "#526193",
      "margin-right": "5px"
    }
  }), _vm._v(" Room 1208, No.36, 1200 Changqing Road, "), _c('div', {
    staticStyle: {
      "position": "relative",
      "top": "-5px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "23px"
    }
  }, [_vm._v("Pudong New Area, Shanghai")])])])])
}]}

/***/ }),

/***/ 428:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-expand-lg navbar-light bg-white",
    staticStyle: {
      "box-shadow": "2px 2px 5px #ccc"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    staticStyle: {
      "justify-content": "right",
      "position": "relative",
      "top": "15px"
    },
    attrs: {
      "id": "navbarCollapse"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "20px",
      "top": "-30px",
      "font-size": "14px",
      "color": "#666"
    }
  }, [_c('i', {
    staticClass: "bi bi-envelope-fill",
    staticStyle: {
      "color": "#526193",
      "margin-right": "5px"
    }
  }), _vm._v(" cliff@adachemicals.com\n          \n            "), _c('img', {
    staticStyle: {
      "width": "25px",
      "height": "18px",
      "cursor": "pointer",
      "margin-left": "10px"
    },
    attrs: {
      "src": "/static/images/en.jpeg"
    },
    on: {
      "click": function($event) {
        return _vm.changeLocale('en')
      }
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "25px",
      "height": "18px",
      "cursor": "pointer",
      "margin-left": "3px"
    },
    attrs: {
      "src": "/static/images/zh.jpeg"
    },
    on: {
      "click": function($event) {
        return _vm.changeLocale('zh')
      }
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "navbar-nav ms-auto"
  }, [_c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "navbarLandings"
    },
    on: {
      "click": function($event) {
        return _vm.jump('/')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('menu_home')) + "\n              ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "aboutUsMenu",
      "data-bs-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('menu_about')) + " "), _c('i', {
    staticClass: "bi bi-chevron-down",
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "aboutUsMenu"
    }
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump('aboutus')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_about_company')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump('team')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_about_team')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump('customer')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_about_customer')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump('partner')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_about_partner')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "productMenu",
      "data-bs-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('menu_product')) + " "), _c('i', {
    staticClass: "bi bi-chevron-down",
    staticStyle: {
      "font-size": "12px",
      "font-weight": "bold"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "productMenu"
    }
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump1('1')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_product_1')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump1('2')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_product_2')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump1('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_product_3')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        return _vm.jump1('4')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu_product_4')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "navbarAccount"
    },
    on: {
      "click": function($event) {
        return _vm.jump('service')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('menu_service')) + "\n              ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "navbarAccount"
    },
    on: {
      "click": function($event) {
        return _vm.jump('contactus')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('menu_contact')) + "\n              ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "navbar-brand-img",
    attrs: {
      "src": "/static/images/logo.png",
      "alt": "..."
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler",
    attrs: {
      "id": "menuButton",
      "type": "button",
      "data-bs-toggle": "collapse",
      "data-bs-target": "#navbarCollapse",
      "aria-controls": "navbarCollapse",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
}]}

/***/ }),

/***/ 431:
/***/ (function(module, exports) {

module.exports = {"menu_home":"HOME","menu_about":"ABOUT US","menu_about_company":"Company","menu_about_team":"Team","menu_about_customer":"Customer","menu_about_partner":"Partner","menu_product":"PRODUCT","menu_product_1":"Aluminium Hydroxide","menu_product_2":"Boron Nitride","menu_product_3":"PVC Additives","menu_product_4":"Raw Materials","menu_service":"SERVICE","menu_contact":"CONTACT","menu_product_left":"Product Category","left_q_title":"FAQs","left_q_1":"Can I get a sample?","left_q_2":"What is the MOQ?","left_q_3":"About technical support","left_q_4":"About payment","left_q_5":"About OEM service","home_title":"Welcome to ADA CHEMICALS","home_desc_1":"ADA Chemical is a professional manufacture of chemical raw materials. Our sales and service center is in shanghai, and our production base is located in Zibo City, Shandong Province. It is south of Qilu Petrochemical Corporation, which is well-known as the supper-large chemical city in China.","home_desc_2":"Established in 1995, we have more than 20 years’experience in chemical raw material industry. Now the company has an asset of over 50,000,000RMB, covers 10,000 square meters, and we have more than 120 employees now","home_view_detail":"View Detail","home_about_section_1":"Factory","home_about_section_1_detail":"Covers 10,000 square meters，located in large chemical city.","home_about_section_2":"Production","home_about_section_2_detail":"Dedicated manufacturer, five independent production line.","home_about_section_3":"R&D","home_about_section_3_detail":"Professional and experienced staff, we are chemical people.","home_about_section_4":"Quality","home_about_section_4_detail":"Fast delivery and strict quality inspection for every shipment.","home_product":"Main Product","home_product_section_1":"Aluminium Hydroxide","home_product_section_1_detail":"Different particle size available，superfine model up to 1um","home_product_section_2":"Boron Nitride","home_product_section_2_detail":"Competitive price with high quality, both powders and coating","home_product_section_3":"PVC Stabilizer","home_product_section_3_detail":"Different model available，fast shipment and delivery to worldwide","home_product_section_4":"Calcium Stearate","home_product_section_4_detail":"Professional supplier, fast shipment and delivery to worldwide","home_product_section_5":"Boron nitride coating","home_adv":"Our Advantages","home_adv_section_1":"Factory direct price to low down your costs","home_adv_section_1_detail":"ADA Chemical is a professional manufacture of chemical materials. We have more than 20 years experience in chemical raw material industry. To provide customers with our best quality products and services is always our consistent pursuit. Our factory direct prices will low down your cost and help you to grow your business.","home_adv_section_2":"Professional technical support","home_adv_section_2_detail":"Our technical expert and customer service staff will provide free consulting service, to help you to find the most suitable material for your application, and also consulting service through your testing process.","home_adv_section_3":"Fast shipment and delivery","home_adv_section_3_detail":"We always provide fast delivery and strict quality inspection for every shipment, various packing and OEM service are available upon customer’s requirement, our specialist will also provide professional service for the whole export process.","service_title_1":"Keeping in mind of our 6S concept (Sincere, Speedy, Specialized, Smart, Smiling, Support), our technical expert and customer service staff are always ready to provide our best service to you.","service_title_2":"Here are some frequently asked questions for your reference:","service_q_1":"Can I get a sample?","service_a_1":"Yes, we can provide samples. But please note that you need to pay for the cost by yourself. Our samples will send directly from China, and the international courier cost could be expensive. Our minimum package is usually 500g, and the cost is around 50-100 USD due to different worldwide destination.","service_q_2":"What is the MOQ?","service_a_2":"The MOQ is different for different products, but we are only doing direct whole sale business, for example, for Aluminum Hydroxide and PVC Resin, we usually sell based on container basis. So if you need only small amount, we suggest that you may buy from your local market, because the shipping cost could be expensive.","service_q_3":"About technical support","service_a_3":"We will provide consulting service to help you to find the most suitable material for your application, and also technical support through your whole application process.","service_q_4":"About payment","service_a_4":"We only accept TT bank transfer or LC payment method. Small amount payment for samples can also be paid by PAYPAL.","service_q_5":"About OEM service","service_a_5":"OEM service is available for most of our products, please contact with our sales staff for details.","contact_1":"Sales & Service","contact_tel":"Tel: ","contact_email":"Email: ","contact_fax":"Fax: ","contact_mobile":"Mobile/Wechat: ","contact_2":"Factory Address","contact_empty":"","contact_3":"Shanghai Office","contact_addr_1":"No.2 Bianhe Road, Bianhe Town, Linzi District Zibo City, Shandong, China","contact_addr_2":"Room 1208, No.36, 1200 Changqing Road, Pudong New Area, Shanghai","form_1":"Enter Your Name*","form_2":"Enter Your Email*","form_3":"Your phone or Whatsapp","form_4":"Type your message*","form_submit":"Submit Inquiry","form_submitted":"Thanks for your inquiry, we will reply soon.","product_1":"MF","product_2":"CAS No.","product_3":"Appearance","product_4":"HS Code","product_5":"Chemical name","product_6":"Content","product_7":"Melting Point","product_8":"White Powder","product_9":"White Flake","product_10":"Lead or Ca-Zn","team_1":"We always believe in our staff as the most important core value of the company. After 20 years of development and accumulation, we now have nearly 100 employees, successfully established a professional research development team and also a experienced product line team.","team_2":"We have a good personnel structure, which includes several highly educated technical experts, and a large number of experienced workers at different divisions. In order to develop the good quality product for customers, we also regularly hire and consult industry experts from related colleges, to track the market cutting-edge technology and industry development trend.","partner_1":"Keep in mind the 'win-win cooperation' business philosophy, we actively carry out cooperation with various business partners.","partner_2":"After more than 20 years’ business development, the company has established partnership with Petro china, Sinopec, Chalco and other major chemical groups in China. In order to meet the needs of the overseas market, we also cooperate with some major international freight company, to provide the best service to our customers.","customer_1":"Not only the business in mainland China , we are also actively expanding overseas market, such as southeast Asia, Middle East, North America, and other regions. After years of market development, we successfully established business partnership with some well-known manufacturers, and we are also working closely with small and medium enterprises.","customer_2":"To provide customers with our best quality products and services is always our consistent pursuit."}

/***/ }),

/***/ 432:
/***/ (function(module, exports) {

module.exports = {"menu_home":"首页","menu_about":"关于我们","menu_about_company":"公司简介","menu_about_team":"员工风采","menu_about_customer":"客户案例","menu_about_partner":"合作伙伴","menu_product":"产品中心","menu_product_1":"氢氧化铝","menu_product_2":"氮化硼","menu_product_3":"PVC助剂","menu_product_4":"其他原材料","menu_service":"专业服务","menu_contact":"联系我们","menu_product_left":"产品目录","left_q_title":"问题解答","left_q_1":"获取样品","left_q_2":"最小起订","left_q_3":"技术支持","left_q_4":"付款方式","left_q_5":"OEM服务","home_title":"欢迎来到爱代化工","home_desc_1":"爱代化工是一家专业的化工原材料生产厂家，公司成立于1995年，生产基地座落于山东淄博，并在上海设有销售和服务中心。","home_desc_2":"公司主要产品有氢氧化铝，氮化硼，PVC添加剂等，广泛应用于PVC、橡胶、建材、电子、水处理等多个领域，并长期出口东南亚、中东、及欧美的多个国家和地区。","home_view_detail":"查看详情","home_about_section_1":"生产基地","home_about_section_1_detail":"专业化工园区，占地面积10000平方米。","home_about_section_2":"生产设备","home_about_section_2_detail":"多条独立生产线和检测设备，30年化工行业经验。","home_about_section_3":"技术研发","home_about_section_3_detail":"高素质员工队伍，配备全套精密仪器。","home_about_section_4":"销售与服务","home_about_section_4_detail":"优良的产品质量和服务，以满足客户为己任。","home_product":"主要产品","home_product_section_1":"氢氧化铝","home_product_section_1_detail":"","home_product_section_2":"氮化硼","home_product_section_2_detail":"","home_product_section_3":"PVC稳定剂","home_product_section_3_detail":"","home_product_section_4":"硬脂酸钙","home_product_section_4_detail":"","home_product_section_5":"氮化硼涂料","home_adv":"我们的优势","home_adv_section_1":"高性价比产品","home_adv_section_1_detail":"专业生产厂家，超过20年化工原料行业经验。为客户提供最好的产品和服务是我们一贯的追求。我们致力于提供高性价比产品，降低客户的生产成本，帮助客户扩大业务。","home_adv_section_2":"专业技术支持","home_adv_section_2_detail":"我们的技术专家和客户服务人员将提供免费的咨询服务，帮助您找到最合适的原材料，并为您产品测试、应用、落地等提供全套的技术支持和售后保障。","home_adv_section_3":"优质售后服务","home_adv_section_3_detail":"在提供优质产品的同时，我们也高度关注快速交付能力和严格的质量检查。各种包装和OEM服务可按照客户的要求来严格执行。我们的专业团队还将为整个出口过程提供专业服务。","service_title_1":"我们的技术专家和客户服务人员致力于提供最优质的服务，帮助您找到合适的原材料，并为您产品测试、应用、落地等提供全套的技术支持和售后保障","service_title_2":"","service_q_1":"关于样品","service_a_1":"根据不同的产品和客户需求，我们可以提供1-5公斤的免费样品","service_q_2":"最小起订量","service_a_2":"大部分产品的最小起订量为1吨。具体请联系我们的销售人员","service_q_3":"技术支持","service_a_3":"我们将提供咨询服务，帮助您找到最适合您申请的材料，并在您的整个申请过程中提供技术支持。","service_q_4":"付款方式","service_a_4":"付款方式一般为款到发货。出口业务，针对不同国家，我们可以接受TT、信用证等不同付款方式。具体请联系我们的销售人员","service_q_5":"OEM服务","service_a_5":"根据客户的行业应用和产品需求，我们可以提供各种定制化的原材料和添加剂。而且，我们也提供各种包装定制和其他相关OEM服务，具体请联系我们的销售人员","contact_1":"销售服务","contact_tel":"电话: ","contact_email":"电子邮箱: ","contact_fax":"传真: ","contact_mobile":"手机/微信: ","contact_2":"工厂地址","contact_empty":"","contact_3":"上海办公室","contact_addr_1":"山东省淄博市临淄区边河镇边河路2号","contact_addr_2":"上海市浦东新区长清路1200弄36号1208","form_1":"请输入您的称呼*","form_2":"请输入您的邮箱*","form_3":"请输入联系电话或其他联系方式","form_4":"请输入您的附言*","form_submit":"提交询盘","form_submitted":"感谢您的询问，我们将尽快回复您的询盘.","product_1":"分子式","product_2":"CAS编号","product_3":"外观","product_4":"HS编码","product_5":"化学名称","product_6":"主要成分","product_7":"熔点","product_8":"白色粉末","product_9":"白色片状粉末","product_10":"铅盐/钙锌","team_1":"我们始终相信员工是公司最重要的核心价值观。经过20年的发展和积累，我们现在拥有近100名员工，成功建立了一支专业的研发团队和一支经验丰富的产品线团队。","team_2":"我们有一个良好的人员结构，包括几位受过高等教育的技术专家，以及大量经验丰富的不同部门的工人。为了为客户开发出优质的产品，我们还定期聘请和咨询相关院校的行业专家，跟踪市场前沿技术和行业发展趋势。","partner_1":"秉承“合作共赢”的经营理念，我们积极与各类商业伙伴开展合作。","partner_2":"经过20多年的业务发展，公司已与中国石油、中石化、中国铝业等国内主要化工集团建立了合作伙伴关系。为了满足海外市场的需求，我们还与一些主要的国际货运公司合作，为我们的客户提供最好的服务。","customer_1":"不仅在中国内地开展业务，我们还积极拓展海外市场，如东南亚、中东、北美等地区。经过多年的市场开发，我们成功地与一些知名制造商建立了业务合作伙伴关系，我们也与中小企业密切合作。","customer_2":"为客户提供最优质的产品和服务是我们一贯的追求。"}

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(145);
module.exports = __webpack_require__(144);


/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(100);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _vue2.default();

/***/ })

},[433]);


// WEBPACK FOOTER //
// static/js/app.97b9d508735caaf50623.js